function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgHatch = function SvgHatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.867 1.02c2.343.8 3.864 2.206 4.65 3.675 3.062.022 5.566.33 7.902 1.623.28.155.547.358.77.614.773.886 1.08 1.776 1.06 2.604-.02.815-.355 1.5-.741 1.996-.48.615-1.227.793-1.84.793h-.864c-.28 1.627-1.678 2.875-3.377 2.875-1.7 0-3.098-1.248-3.378-2.874H9.304c-.28 1.626-1.679 2.874-3.378 2.874-1.798 0-3.26-1.397-3.415-3.162l-1.034-.768a1.8 1.8 0 01-.486-2.345l.103-.177a.2.2 0 00.025-.127L.96 7.474a3.03 3.03 0 01.915-2.609c.93-2.137 1.755-3.339 2.686-3.978.769-.527 1.556-.63 2.336-.65a.606.606 0 01.075-.004h5.589c.264 0 .522-.002.777-.004 1.87-.015 3.533-.028 5.528.79zm-11.941.418c-.697.02-1.192.1-1.685.438-.561.385-1.18 1.152-1.94 2.752l3.625.025V1.438zm.596 4.419H7.52l-4.906-.034a1.83 1.83 0 00-.465 1.488l.157 1.146a1.4 1.4 0 01-.174.89l-.103.178a.6.6 0 00.162.782l.471.35c.444-1.392 1.732-2.405 3.263-2.405 1.7 0 3.098 1.247 3.378 2.874h13.745c.28-1.627 1.679-2.874 3.378-2.874s3.097 1.247 3.377 2.874h.863c.426 0 .735-.127.894-.331.271-.348.477-.791.489-1.288.012-.484-.159-1.091-.765-1.787a1.65 1.65 0 00-.447-.353c-2.155-1.192-4.512-1.473-7.694-1.473H12.957l-5.435-.037zm.603-1.196V1.433h3.888l.292 3.257-4.18-.029zm5.385.033h8.596c-.707-.992-1.886-1.948-3.643-2.545a.6.6 0 01-.036-.013c-1.767-.729-3.19-.72-5.073-.707l-.137.001.293 3.264zm-.675 2.744a.6.6 0 01.6-.6h1.43a.6.6 0 010 1.2h-1.43a.6.6 0 01-.6-.6zM5.926 9.451c-1.222 0-2.229 1.01-2.229 2.275S4.704 14 5.927 14c1.221 0 2.228-1.009 2.228-2.274 0-1.266-1.007-2.275-2.229-2.275zm20.5 0c-1.221 0-2.228 1.01-2.228 2.275S25.205 14 26.427 14c1.222 0 2.229-1.009 2.229-2.274 0-1.266-1.007-2.275-2.23-2.275z",
    fill: props.color
  }));
};
SvgHatch.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgHatch.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgHatch;